export const Typo = {
	TITLE_M_BOLD: 'title-m-bold',
	TEXT_M: 'text-m',
	TEXT_M_BOLD: 'text-m-bold',

	TITLE_S_BOLD: 'title-s-bold',
	TITLE_L_BOLD: 'title-L-bold',
};
